// extracted by mini-css-extract-plugin
export var clickableWrapper = "_2z-2";
export var placeholderIcon = "_2z-3";
export var thumbnailCanvas = "_2z-1";
export var thumbnailWrapper = "_2z-0";